s = window.s || {};
s.dom = s.dom || {};

crossroads.addRoute('', function() {	
	var city = s.dom.$main.find('.cities a.active');
	var code = city.data('code');
	
	setData(code);
});

crossroads.addRoute('chelyabinsk', function() {
	setData('chelyabinsk');
});

crossroads.addRoute('ekaterinburg', function() {
	setData('ekaterinburg');
});

crossroads.addRoute('sochi', function() {
	setData('sochi');
});

crossroads.addRoute('saint-petersburg', function() {
	setData('saint-petersburg');
});

crossroads.addRoute('moscow', function() {
	setData('moscow');
});

function parseHash(newHash, oldHash){
	crossroads.parse(newHash);
}

function setData(code) {	
	s.dom.$main.find('.cities a').removeClass('active');
	s.dom.$main.find('[data-code="'+code+'"]').addClass('active');
	s.dom.$main.find('#js-artists').load('/assets/default/pages/tour/artists/'+code+'.html');
	s.dom.$main.find('#js-place').load('/assets/default/pages/tour/places/'+code+'.html');
	
	var city = s.dom.$main.find('.cities a.active');
	var cityInfo = s.dom.$main.find('#js-city-info');
	
	cityInfo.find('strong').text(city.text());
	cityInfo.find('span').text(city.data('info'));
}

$(document).ready(function() {
	hasher.initialized.add(parseHash);
	hasher.changed.add(parseHash);
	hasher.init();
});